export function billingPath(isAgency?: boolean): string {
  return isAgency ? "/agency/settings/billing" : "/settings/workspace/billing";
}

export function subscribePath(isAgency?: boolean): string {
  return isAgency
    ? "/agency/settings/billing/subscribe"
    : "/settings/workspace/billing/subscribe";
}

export function usagePath(isAgency?: boolean): string {
  return isAgency
    ? "/agency/settings/billing/usage"
    : "/settings/workspace/billing/usage";
}
